// extracted by mini-css-extract-plugin
export var alertIcon = "_uw-0";